import { Users, Ship, Building2, Heart, PartyPopper, Home as HomeIcon, UsersRound, Compass } from "lucide-react";
import { IMAGES } from "@/lib/images";
import { PageHero, SectionHeading, FeatureGrid, CTABand } from "@/components/PageBlocks";
import { useSeo } from "@/hooks/useSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const CATEGORIES = [
  { icon: Users, title: "Group Travel", desc: "We coordinate trips for families, friends, and organizations so the group can relax and enjoy.", to: "/group-travel", cta: "Explore This Experience" },
  { icon: Ship, title: "Cruises", desc: "We help you compare ships, itineraries, and cabins to find the right sailing.", to: "/cruises", cta: "Explore This Experience" },
  { icon: Building2, title: "Resorts & Escapes", desc: "We match you to a resort or villa that fits your style, budget, and who's traveling.", to: "/resorts", cta: "Explore This Experience" },
  { icon: Heart, title: "Honeymoons", desc: "We plan a honeymoon built around the two of you.", to: "/honeymoons", cta: "Explore This Experience" },
  { icon: PartyPopper, title: "Destination Weddings & Celebrations", desc: "We help plan celebrations abroad so you can focus on the moment.", to: "/resorts", cta: "Explore This Experience" },
  { icon: HomeIcon, title: "Villas", desc: "We find private homes with the space and privacy your group needs.", to: "/resorts", cta: "Explore This Experience" },
  { icon: UsersRound, title: "Family & Friends Getaways", desc: "We organize the details so everyone travels together with ease.", to: "/group-travel", cta: "Explore This Experience" },
  { icon: Compass, title: "Custom Travel", desc: "Tell us what you're imagining and we'll help build the trip around it.", to: "/start-your-journey", cta: "Start Your Journey" },
];

export default function Experiences() {
  useSeo({ title: "Travel, Your Way | Inforno Travel", description: "From group getaways and cruises to resorts, honeymoons, celebrations, and custom trips, Inforno Travel helps bring the details together around how you want to travel." });
  return (
    <div className="bg-noir min-h-screen">
      <Navbar />
      <PageHero overline="Experiences" title="Travel, Your Way." image={IMAGES.resort}
        sub="From group getaways and cruises to resorts, honeymoons, celebrations, and personalized trips, Inforno Travel helps bring the details together around the way you want to travel."
        primary={{ label: "Start Your Journey", to: "/start-your-journey" }} />

      <section className="py-24 md:py-32 px-6 md:px-12 bg-noir">
        <div className="max-w-[1500px] mx-auto">
          <div className="mb-14"><SectionHeading overline="What We Do" title="Ways to travel with Inforno" /></div>
          <FeatureGrid items={CATEGORIES} cols={3} />
        </div>
      </section>

      <CTABand eyebrow="However you like to travel" title="Tell us what you're imagining." showRtb />
      <Footer />
    </div>
  );
}
